import { Loader2 } from "lucide-react";
import { useState } from "react";
import { Link, Navigate, useNavigate } from "react-router";
import { Button } from "@/components/ui/button";
import { useCanteiros } from "@/features/canteiros/hooks/use-canteiros";
import { ObraFormDialog } from "@/features/stages/components/obra-form-dialog";
import { useObras } from "@/features/stages/hooks/use-obras";
import { obraUrlKey } from "@/features/stages/obra";
import { useActiveContext } from "@/store/use-active-context";

export function ObraRedirect() {
	const { data: obras, isPending: obrasPending, isError: obrasError } = useObras();
	const { data: canteiros, isPending: canteirosPending } = useCanteiros();
	const activeObraId = useActiveContext((state) => state.activeObraId);
	const setActiveCanteiro = useActiveContext((state) => state.setActiveCanteiro);
	const navigate = useNavigate();
	const [createOpen, setCreateOpen] = useState(false);

	if (obrasPending || canteirosPending) {
		return (
			<div className="route-loading">
				<Loader2 />
			</div>
		);
	}

	if (obrasError) {
		return (
			<div className="route-message">
				<p>Não foi possível carregar as obras.</p>
			</div>
		);
	}

	const target = obras?.find((obra) => obra.id === activeObraId) ?? obras?.[0];
	if (target) {
		return <Navigate to={`/${obraUrlKey(target)}`} replace />;
	}

	const firstCanteiro = canteiros?.[0];
	if (firstCanteiro) {
		return (
			<div className="route-message">
				<p>Seu canteiro está pronto. Cadastre sua primeira obra para começar.</p>
				<Button
					onClick={() => {
						setActiveCanteiro(firstCanteiro.id);
						setCreateOpen(true);
					}}
				>
					Cadastrar obra
				</Button>
				<ObraFormDialog
					open={createOpen}
					onOpenChange={setCreateOpen}
					onCreated={(id) => navigate(`/${id}`)}
				/>
			</div>
		);
	}

	return (
		<div className="route-message">
			<p>Você ainda não tem nenhum canteiro.</p>
			<Button asChild>
				<Link to="/novo-canteiro">Cadastrar canteiro</Link>
			</Button>
		</div>
	);
}
